import React from "react";
import { Typography } from "@mui/material";
import CustomDataGrid from "../../CustomDataGrid";
import { Box, Avatar, Tooltip } from "@mui/material";
import { text } from "@fortawesome/fontawesome-svg-core";

const CuentaCorrienteTab = ({ dataRows }) => {
  const columnsObject = [
    { field: "fecha_hora", headerName: "Fecha", flex: 1 },
    {
      field: "usuario",
      headerName: "usuario",
      flex: 1,
      textTransform: "capitalize",
    },
    {
      field: "observacion",
      headerName: "Notas",
      flex: 5,
      wrap: true,
      renderCell: (params) => (
        <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
          {params.value.toString().toLowerCase()}
        </div>
      ),
    },
  ];
  return (
    <Box>
      <CustomDataGrid
        columnsObject={columnsObject}
        dataRows={dataRows}
        sortField="fecha_usa"
        sortOrder="desc"
        dynamicRowHeightField="observacion"
        columnPercentage={0.9}
      />
    </Box>
  );
};

export default CuentaCorrienteTab;
